import api from 'api';

export const MENU_ITEM_SALE_ASYNC_ACTION_START = 'MENU_ITEM_SALE_ASYNC_ACTION_START';
export const MENU_ITEM_SALE_ASYNC_ACTION_ERROR = 'MENU_ITEM_SALE_ASYNC_ACTION_ERROR';
export const MENU_ITEM_SALE_ASYNC_UPDATE_ACTION_SUCCESS = 'MENU_ITEM_SALE_ASYNC_UPDATE_ACTION_SUCCESS';
export const MENU_ITEM_SALE_UPDATE_ACTION_SUCCESS = 'MENU_ITEM_SALE_UPDATE_ACTION_SUCCESS';
export const MENU_ITEM_SALE_RESET_STATE = 'MENU_ITEM_SALE_RESET_STATE';

function menuItemSaleAsyncActionStart() {
  return {
    type: MENU_ITEM_SALE_ASYNC_ACTION_START,
  };
}

function menuItemSaleAsyncActionError(error) {
  return {
    type: MENU_ITEM_SALE_ASYNC_ACTION_ERROR,
    error,
  };
}

function menuItemSaleAsyncUpdateSuccess(data) {
  return {
    type: MENU_ITEM_SALE_ASYNC_UPDATE_ACTION_SUCCESS,
    data,
  };
}

export function updateMenuItemSale(data) {
  return {
    type: MENU_ITEM_SALE_UPDATE_ACTION_SUCCESS,
    data,
  };
}

export function resetMenuItemSaleState() {
  return {
    type: MENU_ITEM_SALE_RESET_STATE,
  };
}

export function getMenuItemSaleAsync(id) {
  return (dispatch, getState) => {
    dispatch(menuItemSaleAsyncActionStart());
    return api.request(`menuItemSale/${ id }`, 'get')
    .then((data) => {
      dispatch(menuItemSaleAsyncUpdateSuccess(data));
      return data;
    })
    .catch((err) => {
      dispatch(menuItemSaleAsyncActionError('Unable to get menu item sale'));
      throw (err);
    });
  };
}

export function createMenuItemSaleAsync(menuItemSale) {
  return (dispatch, getState) => {
    dispatch(menuItemSaleAsyncActionStart());
    return api.request('menuItemSale', 'post', menuItemSale)
    .then((data) => {
      dispatch(menuItemSaleAsyncUpdateSuccess(data));
      return data;
    })
    .catch((err) => {
      dispatch(menuItemSaleAsyncActionError('Unable to create menu item sale'));
      throw (err);
    });
  };
}

export function updateMenuItemSaleAsync(menuItemSale) {
  return (dispatch, getState) => {
    dispatch(menuItemSaleAsyncActionStart());
    return api.request(`menuItemSale/${menuItemSale.id}`, 'put', menuItemSale)
    .then((data) => {
      dispatch(menuItemSaleAsyncUpdateSuccess(data));
      return data;
    })
    .catch((err) => {
      dispatch(menuItemSaleAsyncActionError('Unable to update menu item sale'));
      throw (err);
    });
  };
}
